import React from "react"
import {ItemRenderer, Select} from "@blueprintjs/select"
import {$enum} from "ts-enum-util"
import {useSelector} from "react-redux"
import {MenuItem} from "@blueprintjs/core"
import isInternOnly from "../../../core/selectors/core.selector"
import Props from "../../../core/components/props"
import MinimalButton from "../../../core/components/buttons/MinimalButton"
import {
    FilterType,
    FilterTypeProperties,
} from "../../../shared/enums/filterType"

const Combobox = Select.ofType<FilterType>()

export interface FilterTypeSelectProps extends Props {
    selectedValue: FilterType
    setSelectedValue: (value: FilterType) => void
}

const FilterTypeSelect: React.FC<FilterTypeSelectProps> = (props) => {
    const {className, id, selectedValue, setSelectedValue} = props
    const isInternal: boolean = useSelector(isInternOnly)

    const renderValueType: ItemRenderer<FilterType> = (
        valueType,
        {handleClick, modifiers, query}
    ) => {
        if (!modifiers.matchesPredicate) {
            return null
        }
        if (FilterTypeProperties[valueType].internOnly && !isInternal) {
            return null
        }
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                text={FilterTypeProperties[valueType].label}
                key={valueType}
                onClick={handleClick}
                shouldDismissPopover={false}
            />
        )
    }

    return (
        <div>
            <Combobox
                className={className}
                items={[0, 1, 2]} // TODO: should be $enum(FilterType).getValues() from unknown reasons stops work
                itemRenderer={renderValueType}
                onItemSelect={(valueType: FilterType) =>
                    setSelectedValue(valueType)
                }
                activeItem={selectedValue}
                filterable={false}
            >
                <MinimalButton
                    rightIcon="caret-down"
                    text={
                        FilterTypeProperties[selectedValue]
                            ? FilterTypeProperties[selectedValue].label
                            : ""
                    }
                    id={id}
                />
            </Combobox>
        </div>
    )
}

export default FilterTypeSelect
